/* ============================================================================
 * 页面注册表
 * 迁移纪律（版本演进与能力累积）：V2 有 27 个可用页面，V3 不得少于 27 个。
 * 2026-08-10：21 个「迁移中」占位已全部替换为真实页面，占位机制随之移除。
 * 若未来再有未完成的页面，宁可显示「迁移中」并列出待补能力，也不用假内容占位。
 * ========================================================================== */
import { lazy, type ComponentType } from 'react';

const Home = lazy(() => import('@/pages/Home'));
const Orders = lazy(() => import('@/pages/Orders'));
const FactorySchedule = lazy(() => import('@/pages/FactorySchedule'));
const Demand = lazy(() => import('@/pages/Demand'));
const Operational = lazy(() => import('@/pages/Operational'));
const Resources = lazy(() => import('@/pages/Resources'));
const Overview = lazy(() => import('@/pages/Overview'));
const Plant = lazy(() => import('@/pages/Plant'));
const Reports = lazy(() => import('@/pages/Reports'));
const Benchmark = lazy(() => import('@/pages/Benchmark'));
const Sop = lazy(() => import('@/pages/Sop'));
const Plan = lazy(() => import('@/pages/Plan'));
const Approval = lazy(() => import('@/pages/Approval'));
const Rules = lazy(() => import('@/pages/Rules'));
const Emergency = lazy(() => import('@/pages/Emergency'));
const Whatif = lazy(() => import('@/pages/Whatif'));
const Capacity = lazy(() => import('@/pages/Capacity'));
const Atp = lazy(() => import('@/pages/Atp'));
const Customer = lazy(() => import('@/pages/Customer'));
const Material = lazy(() => import('@/pages/Material'));
const Inventory = lazy(() => import('@/pages/Inventory'));
const Tower = lazy(() => import('@/pages/Tower'));
const Trace = lazy(() => import('@/pages/Trace'));
const Master = lazy(() => import('@/pages/Master'));
const Integration = lazy(() => import('@/pages/Integration'));
const Permissions = lazy(() => import('@/pages/Permissions'));
const AiConfig = lazy(() => import('@/pages/AiConfig'));

export const PAGES: Record<string, ComponentType> = {
  home: Home,
  orders: Orders,
  factory: FactorySchedule,
  demand: Demand,
  operational: Operational,
  resources: Resources,

  overview: Overview,
  plant: Plant,
  reports: Reports,
  benchmark: Benchmark,
  sop: Sop,
  plan: Plan,
  approval: Approval,
  emergency: Emergency,
  whatif: Whatif,
  capacity: Capacity,
  rules: Rules,
  atp: Atp,
  customer: Customer,
  material: Material,
  inventory: Inventory,
  tower: Tower,
  trace: Trace,
  master: Master,
  integration: Integration,
  permissions: Permissions,
  aiconfig: AiConfig,
};
